module.exports = __webpack_public_path__ + "9788f41e/img/pwrd-by-sourcery-black.bba9ba41.svg";